<template> 
  <div class="page-login">
    <Sbanner :detailInfo="detailOne" />
    <div class="container login-box">
      <div class="login-content" v-if="type=='tel'">
        <h4 class="login-title">手机号码登录</h4>
        <div class="login-item">
          <p class="txt">手机号</p>
          <div class="item-input">
            <input type="text" v-model="userTel" placeholder="请输入您的手机号">
          </div>
        </div>
        
        <div class="login-item">
          <p class="txt">手机验证码</p>
          <div class="item-input">
            <input type="text" v-model="code" placeholder="请输入手机验证码" @keyup.enter='loginTel' >
            <em class="label-right send-verify" :class="isCountDown?'isSend':''" @click="sendVerify">
              {{isCountDown?'重新获取（'+CountDownTime+'s）':'发送验证码'}}
            </em>
          </div>
        </div>

        <div class="noticexx">
          <transition name="fade">
            <notice :type="'error'" v-if="noticeShow">
              <template v-slot:noticeTxt>
                {{noticeWarn}}
              </template>
            </notice>
          </transition>
        </div>

        <div class="login-btn" @click="loginTel">登录</div>
        <p class="login-tips" >没有账号？<em  @click="goPage('/register')">立即注册</em></p>


        <div class="other-login">
          <div class="other-tt">其他登录方式</div>
          <div class="other-icon" @click="changeLoginType('scan')">
            <span class="iconfont icon-wechat-2-fill"></span>
          </div>
        </div>
      </div>

      <div class="login-content" v-if="type=='user'">
        <h4 class="login-title">用户名登录</h4>
        <div class="login-item">
          <p class="txt">用户名</p>
          <div class="item-input">
            <input type="text" v-model="username"  placeholder="请输入用户名">
          </div>
        </div>

        <div class="login-item">
          <p class="txt">登录密码</p>
          <div class="item-input">
            <input :type="isSee?'text':'password'" v-model="pwd"  @keyup.enter='loginUser' placeholder="请输入登录密码">
            <span class="label-right iconfont " :class="isSee?'icon-eye-line':'icon-eye-close-line'"  @click="showPwd"></span>
          </div>
        </div>
        <div class="noticexx">
          <transition name="fade">
            <notice :type="'error'" v-if="noticeShow">
              <template v-slot:noticeTxt>
                {{noticeWarn}}
              </template>
            </notice>
          </transition>
        </div>

        <div class="login-btn" @click="loginUser">登录</div>
        <p class="login-tips" >
          <em  @click="goPage('register')">新用户注册</em>
          <em class="ff" @click="goPage('findPassword')">忘记密码？</em></p>


        <div class="other-login">
          <div class="other-tt">其他登录方式</div>
          <div class="other-icon" @click="changeLoginType('tel')">
            <span class="iconfont icon-smartphone-line"></span>
          </div>
        </div>
      </div>

      <div class="login-content" v-if="type=='scan'">
        <h4 class="login-title">微信扫一扫登录</h4>
        
        <div class="loginQr flex jc">
          <div class="imgs flex jc">
            <!-- <img :src="dataQr" alt=""> -->
            <el-image style="width: 300px; height: 300px" :src="dataQr" fit="contain" v-if="!isIe">
               <div class="img-loading flex jc" slot="error" >
                <i class="el-icon-loading"></i>
               </div>
            </el-image>
            <el-image style="width: 300px; height: 300px" src="/images/login.png" fit="contain" v-else />
            <div class="reloadQr flex center jc" v-if="isPassed">
              <p class="reload-btn" @click="reLoadQr">
                <span class="refresh el-icon-refresh"></span>
                <em>点击刷新</em>
              </p>
            </div>
          </div>
        </div>

        <div class="other-login">
          <div class="other-tt">其他登录方式</div>
          <div class="other-icon" @click="changeLoginType('tel')">
            <span class="iconfont icon-smartphone-line"></span>
          </div>
        </div>
      </div>

    </div>

    <popInfo positions='fixed' v-if="loginSuccss">
      <div class="reback">
        <span class="iconfont icon-check"></span>
        <p>登录成功</p>
      </div>
    </popInfo>
      <puzzle-vcode :show="VcodeShow" @success="VcodeSuccess" @close="VcodeClose"/>
    <!-- <Vcode :show="VcodeShow" @success="VcodeSuccess" @close="VcodeClose" /> -->
  </div>
</template>

<script>
import Sbanner from '../components/sbanner.vue'
import notice from "../components/common/notice.vue"
import popInfo from "../components/common/popInfo.vue"
import { mapMutations, mapState } from 'vuex';
import PuzzleVcode from "../components/PuzzleVcode/index.vue"
import { encrypt,decrypt } from '../utils/sm4Util';
import QRCode from 'qrcode'
import configs from '@/config/config'
export default {
  
  name: 'login',
  components: {   Sbanner ,notice,popInfo, PuzzleVcode},
  props: {
    msg: String
  },
  data(){
    return{
      detailOne:{},
      type:"tel",
      noticeShow:false,
      noticeWarn:'',
      username:'',
      pwd:'',
      showpath:'',

      userTel:'',
      code:'',
      isCountDown:false,
      CountDownTime:59,
      countDownFun:null,
      loginSuccss:false,

      isSee:false,

      VcodeShow:false,
      picCode:'',

      qrCode: '',
      dataQr: '',
      timer: null,
      maxTimes: 12 * 5 * 2,
      curTime: 0,
      duration: 1 * 1000,
      isPassed: false,
      number: '',
      isIe: false,
    }
  },
  computed:{
    ...mapState(['loginTimes',"loginDisTime"]),
  },
  mounted() {
    const ua = window.navigator.userAgent;
    this.isIe = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;

    if(this.$route.params.toPage){
      this.nextPath = this.$route.params.toPage.replace(/-/g,"/")
    }
    this.initPage()
  },
  destroyed() {
    this.clearTimer()
  },
  methods: {
    ...mapMutations(['updateUserInfo',"updateLoginTime"]),
    initPage() {
    },
    async getQr() {
      const host = process.env.NODE_ENV === 'production' ? mUrl : configs.mUrl
      const redirect_uri = `${host}/wjWechatCallback.html`

      const code = this.$utils.generateRandomCode(32)

      const params = {
        appid: window.wxAppid,
        redirect_uri: encodeURIComponent(redirect_uri),
        response_type: 'code',
        scope: 'snsapi_base',
        state: code
      }

      const arr = []
      for (let k in params) {
        arr.push(`${k}=${params[k].trim()}`)
      }

      let url = "https://open.weixin.qq.com/connect/oauth2/authorize"
      url += '?' + arr.join('&') + '#wechat_redirect'

      this.checkResult()
      const resQr = await QRCode.toDataURL(url)
      this.qrCode = code
      this.curTime = 0
      this.isPassed = false
      this.dataQr = resQr
      
      if (this.isIe) {
        this.qrCode = 'poExGDwbeN6plV3v6LakF2552sN86LHw'
      }
    },
    async checkResult() {
      const that = this
      const params = {
        ticket: this.qrCode,
        number: this.qrCode
      }
      const res = await this.$api.userApi.getLoginResult(params)
      if(res.data){
        this.loginSuccess(res)
      }else{
        this.clearTimer()
        this.timer = setTimeout(() => {
          if (that.curTime < that.maxTimes) {
            that.curTime += 1
            that.checkResult()
          } else {
            that.isPassed = true
            that.clearTimer()
          }
        }, this.duration)
      }
    },
    clearTimer() {
      clearInterval(this.timer)
      this.timer = null
    },
    reLoadQr() {
      this.getQr()
    },
    changeLoginType(type){
      this.noticeShow=false;
      this.noticeWarn='';
      this.type = type;
      if (type == 'scan') {
        this.getQr()
      } else {
        this.clearTimer()
      }
    },
    goPage(page){
      if(page=='register' && this.nextPath){
        path = page +'/'+ this.$route.params.toPage
      }
      this.$router.push(page)
    },
    
    loginUser(){
      if(!this.username || !this.pwd){
        this.showWarn("用户名或密码不能为空！")
        return;
      }
      if(this.loginTimes >=5){
        this.showWarn("错误次数已达上限，请10分钟后重试，或联系管理员找回密码！")
        return;
      }
      let params={
        username:this.username,
        password:encrypt(this.pwd)
      }
      this.$api.userApi.login(params).then(res=>{
        if(res.code===0){
          this.loginSuccess(res)
        }else{
          this.updateLoginTime(parseInt(this.loginTimes + 1),this.username);
          this.noticeWarn =res.msg;
          this.noticeShow=true;
          this.fadeOutWarn();
        }
        
      })
    },
    // 发送手机验证码
    sendVerify(){
      if(this.isCountDown) return;
      if(!this.userTel){
       this.showWarn("请输入手机号获取验证码")
        return;
      }
      if(!this.$utils.isPhone(this.userTel)){
        this.showWarn("请输入正确手机号")
        return;
      }
      //弹出图形验证码
      if(!this.picCode){
        this.VcodeShow = true;
        this.posting = true
        return
      }
      
      let params ={
        phone:encrypt( this.userTel),
        type:1
      }
      this.$api.userApi.getTelVerifyCode(params).then(res=>{
        if(res.code==0){
          this.isCountDown = true;
          this.counDowning();
        }else{
          this.showWarn(res.msg)
        }
      });
    },
    // 倒计时
    counDowning(){
      this.countDownFun =  setInterval(() => {
        this.CountDownTime  = this.CountDownTime -1;
        if(this.CountDownTime==0){
          clearInterval(this.countDownFun);
           this.isCountDown= false;
           this.CountDownTime = 59;
           this.picCode = ''
        }
      }, 1000);
    },
    isEndTime(){
      let nowTime = new Date().getTime()
      if(!this.loginDisTime) return true
      if(nowTime - this.loginDisTime > 10 *60*1000) {
        this.updateLoginTime(0,this.userTel)
        return true
      }
      return false 
    },

    loginTel(){
      
      if(!this.userTel || !this.code){
        this.showWarn('手机号或验证码不能为空');
        return;
      }
      if(!this.$utils.isPhone(this.userTel)){
        this.showWarn("请输入正确手机号")
        return
      }
      if(!this.isEndTime()){
        this.showWarn("当前账户已锁定，请稍后再试")
        return;
      }
      if(this.loginTimes >=5){
        this.showWarn("错误次数已达上限，请10分钟后重试")
        return;
      }
      if (!this.picCode) {
        this.VcodeShow = true
        return
      };
 
      let params ={
        phone:encrypt(this.userTel) ,
        code:this.code
      }
      this.$api.userApi.loginPhone(params).then(res=>{
        if(res.code==0){
          this.loginSuccess(res)
        }else{
          this.updateLoginTime(parseInt(this.loginTimes + 1),this.userTel);
          this.showWarn(res.msg);
          this.picCode = ''
          return
        }
      })

    },
    loginSuccess(res) {
      this.picCode = ''
      this.loginSuccss = true;
      
      setTimeout(() => {
        if(this.nextPath){
          this.$router.replace(this.nextPath)
        }else{
          this.$router.replace("/index")
        }
        this.loginSuccss = false;
      }, 2000);
      let loginInfo={
        ...res.data,
        time:new Date().getTime(),
        user:res.data.username,
        ip:window.ip,
        userPic: res.data.cover_img,
        showpath:res.showpath,
      }
      if (this.username) {
        this.updateLoginTime(0,this.username);
      }
      console.log('loginInfo: ', JSON.parse(JSON.stringify(loginInfo)))
      this.updateUserInfo(loginInfo);
      this.$utils.setCookie("login",JSON.stringify(loginInfo),30)
      this.$utils.setSession("lastLoginTime",new Date().getTime())
    },

    showPwd(){
      this.isSee = !this.isSee
    },


    goHome(){
      this.$router.push({path:'/index'})
    },
    reload(){
      this.$router.go(0)
    },
    showWarn(txt){
      this.noticeWarn = txt;
      this.noticeShow=true;
      this.fadeOutWarn();
    },
    //隐藏警告提示框 
    fadeOutWarn(){
      setTimeout(() => {
        this.noticeShow=false;
        this.noticeWarn='';
      }, 2000);
    },

    //图形验证成功
    VcodeSuccess(e){
      console.log("成功了",e)
      this.VcodeShow = false
      this.picCode = e
      if(this.posting){
        this.sendVerify()
      }else{
        this.loginTel()
      }
    },
    //图形验证关闭
    VcodeClose(e){
      console.log("关闭验证弹窗",e)
      this.VcodeShow = false
    }
  },
}
</script>